var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isTranslationRequired()
    ? _c(
        "div",
        {
          staticClass: "translate-detected",
          on: { click: _vm.activeAutoTranslate },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("message.autoTranslateDetectedDesc", {
                  visitorLanguage: _vm.getVisitorLanguage(),
                })
              ) +
              "\n"
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }